<template>
    <Header>
        <a class="logo" @click="onLogo">
            <img src="static/logo.png"/>
        </a>
        <span class="d-flex-item"/>
        <div class="navs">
            <a class="link" :class="navActive === index ? 'active' : ''" v-for="(item, index) in navArray" :key="index" @click="onLink(item, index)">
                <img :src="navActive === index ? item.iconSet : item.icon"/>
                <span class="mt-ns">{{ item.name }}</span>
            </a>
        </div>
        <div class="d-block plr-md">
            <div class="d-flex justify-start">
                <Dropdown trigger="click">
                    <a class="d-flex justify-start">
                        <Avatar shape="circle" size="large" :src="$store.state.account.logo && $store.state.account.logo !== '' ? 'static/avatar.png' : 'static/avatar.png'" style="background: #eaeaea;"/>
                        <span class="d-flex-item plr-xs overflow-text" style="text-transform: capitalize; font-size: 16px; color: #fff;">{{ $store.state.account.userName }}<br/>{{ $store.state.account.loginName }}</span>
                        <Icon type="ios-arrow-down" size="20" color="#fff"/>
                    </a>
                    <DropdownMenu class="width-160" slot="list" value="">
                        <DropdownItem @click.native="changePassword">修改密码</DropdownItem>
                        <DropdownItem divided class="c-error" @click.native="onLogout">退出登录</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </div>
    </Header>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                navActive: Number(localStorage.getItem('navActive')) || 0,
                navArray: [
                    {
                        icon: 'static/icon-nav/home@24px.png',
                        iconSet: 'static/icon-nav/home-hover@24px.png',
                        name: '首页',
                        path: '/',
                    },
                    {
                        icon: 'static/icon-nav/user@24px.png',
                        iconSet: 'static/icon-nav/user-hover@24px.png',
                        name: '被试档案',
                        path: '/user',
                    },
                    // {
                    //     icon: 'static/icon-nav/task@24px.png',
                    //     iconSet: 'static/icon-nav/task-hover@24px.png',
                    //     name: '任务中心',
                    //     path: '/task',
                    // },
                    {
                        icon: 'static/icon-nav/report@24px.png',
                        iconSet: 'static/icon-nav/report-hover@24px.png',
                        name: '报告中心',
                        path: '/report',
                    },
                    // {
                    //     icon: 'static/icon-nav/yichang@24px.png',
                    //     iconSet: 'static/icon-nav/yichang-hover@24px.png',
                    //     name: '异常登记表',
                    //     path: '/anomaly',
                    // },
                    // {
                    //     icon: 'static/icon-nav/net@24px.png',
                    //     iconSet: 'static/icon-nav/net-hover@24px.png',
                    //     name: '全脑网络',
                    //     path: '',
                    // },
                    {
                        icon: 'static/icon-nav/setting@24px.png',
                        iconSet: 'static/icon-nav/setting-hover@24px.png',
                        name: '设置',
                        path: '/setting',
                    },
                    {
                        icon: 'static/icon-nav/about.png',
                        iconSet: 'static/icon-nav/about-hover@24px.png',
                        name: '关于我们',
                        path: '/about',
                    }                    
                ],
            }
        },
        async beforeDestroy() {
            this.$bus.off('initHeader');
        },
        async mounted() {
            await this.$bus.on('initHeader', async (data) => {
                console.log('this.initHeader---------->', data);
                if (!data) return;
                this.navActive = data;
            });
        },
        methods: {
            async onLogo(){
                await localStorage.removeItem('navActive');
                this.navActive = 0;
                window.location.href = '/';
            },
            async onLink(data, i){
                console.log('this.onLink---------->', data, i);
                if (data.path === ''){
                    return await this.$common.alertModel('info', '研发中，敬请期待');
                }
                this.navActive = i;
                localStorage.setItem('navActive', this.navActive);
                this.$router.push({
                    path: data.path,
                });
            },
            async changePassword(){
                this.$bus.emit('changePassword', true);
            },
            async onLogout(){
                let com = await this.$common.confirmModel('确认退出登录');
                if (!com) return;
                window.localStorage.clear();
                window.location.href = './';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue